import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Chip from '@mui/material/Chip';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { styled } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import TranslateIcon from '@mui/icons-material/Translate';
import DescriptionIcon from '@mui/icons-material/Description';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import swal from 'sweetalert';
import Autocomplete from '@mui/material/Autocomplete';

import Client from './Client';
import Config from './ClientConfig';
import DropDown from './DropDown';
import KImage from './KImage';
import noImage from './../images/noImage.png';
import active_on from './../images/icons/active_on.png';
import active_off from './../images/icons/active_off.png';

const ExpandMore = styled((props) => { const { expand, ...other } = props; return <IconButton {...other} />; })(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)', marginLeft: 'auto', transition: theme.transitions.create('transform', { duration: theme.transitions.duration.shortest, }),
}));

let LANGS_CACHE = null; let LANGS_BY_ID = null; let LANGS_LOADING = null;
const COUNTY_CACHE = new Map();
const NEWS_DESCRIPTION_LIMIT = 256;
const TRANSLATION_DESCRIPTION_LIMIT = 1024;

const StableKImage = React.memo(KImage, (prev, next) => {
  const prevData = (prev.image && prev.image.data) || '';
  const nextData = (next.image && next.image.data) || '';
  return (
    prev.edit === next.edit &&
    prevData === nextData
  );
});

export default class News extends React.Component {
  constructor(props) {
    super(props);
    const today = this.toBusinessDate(new Date().toISOString()).slice(0, 10);
    this.state = {
      client: new Client('none'),
      item: {
        iref: '',
        createdOn: '',
        modifiedOn: '',
        name: '',
        description: '',
        image: null,
        dateFrom: props.isNew ? `${today}T00:00:00` : '',
        dateTo: props.isNew ? `${today}T23:59:59` : '',
        frequency: 0,
        county: null,
        counties: [],
        details: '',
        detailsLanguage: 0,
        type: 1,
        isActive: true,
        pin_position: 0,
      },
      expanded: !!props.isNew,
      edit: !!props.isNew,
      allowEdit: props.allowEdit !== false,
      saveButtonVisible: false,
      tabValue: 'details',
      somethingHasChanged: false,
      isSaving: false,
      imgVersion: 0,

      translations: [],
      trEdit: {},
      languages: [],
      langById: {},
      languagesReady: false,
      isSavingTr: false,

      frequencyOptions: { 0: 'ONCE', 1: 'ONCE_A_DAY', 2: 'ONCE_A_WEEK', 3: 'ONCE_A_MONTH' },
      typeOptions: { 0: 'INTERNAL', 1: 'EXTERNAL', 2: 'BOTH' },
      detailsLangOptions: { 0: 'TEXT', 1: 'HTML', 2: 'MARKUP' },
      pinOptions: { 0: 'None', 1: '1st', 2: '2nd', 3: '3rd' },

      counties: [], countyOpts: {}, countyObjs: [],
      targetMode: 'all',
    };
    this.originalItem = { ...this.state.item, counties: [] };

    this.handleExpandClick = this.handleExpandClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.pushData = this.pushData.bind(this);

    this.changeFrequency = this.changeFrequency.bind(this);
    this.changeType = this.changeType.bind(this);
    this.changeDetailsLang = this.changeDetailsLang.bind(this);
    this.changePinPosition = this.changePinPosition.bind(this);
    this.saveTranslation = this.saveTranslation.bind(this);
    this.addBlankTranslation = this.addBlankTranslation.bind(this);
    this.toggleTrEdit = this.toggleTrEdit.bind(this);

    this.getImage = this.getImage.bind(this);
    this._lastImgRaw = undefined;
    this._kimgImageObj = { data: '' };
  }

  // ---------- date helpers ----------
  toBusinessDate(value) {
    const s = String(value || '').trim();
    if (!/^\d{4}-\d{2}-\d{2}[ T].*(?:Z|[+-]\d{2}:?\d{2})$/i.test(s)) return s;
    const instant = new Date(s.replace(' ', 'T'));
    if (Number.isNaN(instant.getTime())) return '';
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Bucharest',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
    }).formatToParts(instant).map(({ type, value: part }) => [type, part]));
    return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`;
  }

  toPayloadDate(raw, endOfDay = false, preserveOffset = false) {
    if (!raw) return null;
    const s = this.toBusinessDate(raw);
    // An untouched API timestamp retains its exact instant, including at DST overlaps.
    const original = String(raw).trim();
    if (preserveOffset && s && /^\d{4}-\d{2}-\d{2}[ T].*(?:Z|[+-]\d{2}:?\d{2})$/i.test(original)) {
      return original.replace(' ', 'T');
    }
    // Date-only To values include the whole day; preserve explicit times.
    const time = (match) => match[4] === undefined
      ? (endOfDay ? '23:59:59' : '00:00:00')
      : `${match[4]}:${match[5]}:${match[6] || '00'}`;

    // YYYY-MM-DD or YYYY-MM-DD[ T]HH:mm[:ss][.sss][Z]
    let m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/.exec(s);
    if (m) return `${m[1]}-${m[2]}-${m[3]} ${time(m)}`;

    // DD-MM-YYYY or DD-MM-YYYY[ T]HH:mm[:ss]
    m = /^(\d{2})-(\d{2})-(\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/.exec(s);
    if (m) return `${m[3]}-${m[2]}-${m[1]} ${time(m)}`;

    return null;
  }
  toYMD(value) {
    if (!value) return '';
    const s = this.toBusinessDate(value);

    let m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s); // handles YYYY-MM-DD, YYYY-MM-DDTHH:mm:ss
    if (m) return `${m[1]}-${m[2]}-${m[3]}`;

    m = /^(\d{2})-(\d{2})-(\d{4})/.exec(s); // handles DD-MM-YYYY
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;

    return '';
  }
  toDMY(value) {
    if (!value) return '';
    const s = this.toBusinessDate(value);

    let m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s); // YYYY-MM-DD -> DD-MM-YYYY
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;

    m = /^(\d{2})-(\d{2})-(\d{4})/.exec(s); // already DMY
    if (m) return `${m[1]}-${m[2]}-${m[3]}`;

    return '';
  }

  toDateTimeInput = (value, endOfDay = false) => (
    this.toPayloadDate(value, endOfDay)?.slice(0, 16).replace(' ', 'T') || ''
  );

  scheduleLabel = (value, endOfDay = false) => (
    value ? `${this.toDMY(value)} ${this.toPayloadDate(value, endOfDay)?.slice(11, 16) || ''}` : '—'
  );

  changeSchedule = (field, value) => {
    this.setState((state) => {
      const previous = state.item[field];
      let next = value;
      if (next) {
        const oldValue = this.toDateTimeInput(previous, field === 'dateTo');
        const sameTime = oldValue && oldValue.slice(11) === next.slice(11);
        const seconds = sameTime
          ? this.toPayloadDate(previous, field === 'dateTo').slice(17, 19)
          : field === 'dateTo' && next.endsWith('T23:59') ? '59' : '00';
        next = next === oldValue ? previous : `${next}:${seconds}`;
      }
      return {
        item: { ...state.item, [field]: next },
        somethingHasChanged: true,
      };
    });
  };

  hasValidDates = () => {
    const { dateFrom, dateTo } = this.state.item || {};
    if (!dateFrom || !dateTo) return false;
    const d1 = this.toPayloadDate(dateFrom);
    const d2 = this.toPayloadDate(dateTo, true);
    if (!d1 || !d2) return false;
    return d1 <= d2;
  };

  hasRequiredText = (value) => Boolean(String(value ?? '').trim());

  descriptionLength = (value) => Array.from(String(value ?? '').trim()).length;

  hasValidDescription = (value, limit) => (
    this.hasRequiredText(value) && this.descriptionLength(value) <= limit
  );

  descriptionHelperText = (value, limit) => {
    if (!this.hasRequiredText(value)) return 'Required';
    const length = this.descriptionLength(value);
    return `${length}/${limit} characters${length > limit ? ` — maximum ${limit}.` : ''}`;
  };

  saveErrorMessage = (response) => {
    const errors = response?.message || response?.errors || response?.detail || response;
    if (typeof errors === 'string') return errors;
    if (Array.isArray(errors)) return errors.join('\n');
    if (errors && typeof errors === 'object') {
      const messages = Object.entries(errors)
        .filter(([field]) => field !== 'status')
        .map(([field, value]) => {
          const message = Array.isArray(value) ? value.join(' ') : typeof value === 'string' ? value : JSON.stringify(value);
          return `${field}: ${message}`;
        });
      if (messages.length) return messages.join('\n');
    }
    return 'The server did not confirm the save. Check the news list before retrying.';
  };

  componentDidMount() {
    if (this.props.item) {
      const counties = this.countyIds(this.props.item);
      const incoming = {
        ...this.props.item,
        county: counties[0] || null,
        counties,
      };
      this.originalItem = { ...incoming, counties: [...counties] };
      this.setState({
        item: incoming,
        targetMode: counties.length ? 'selected' : 'all',
      }, () => {
        this.updateGeoData('country061', counties);
      });
    } else {
      this.originalItem = { ...this.state.item, counties: [] };
      this.updateGeoData('country061', []);
    }
    this.loadLanguages();
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.item !== this.props.item
      && this.props.item
      && !this.state.edit
    ) {
      const counties = this.countyIds(this.props.item);
      const incoming = {
        ...this.props.item,
        county: counties[0] || null,
        counties,
      };
      this.originalItem = { ...incoming, counties: [...counties] };
      this.setState({
        item: incoming,
        targetMode: counties.length ? 'selected' : 'all',
        somethingHasChanged: false,
      }, () => {
        this.updateGeoData('country061', counties);
      });
    }
  }

  countyId = (county) => {
    if (county && typeof county === 'object') return county.iref || null;
    return county || null;
  };

  countyIds = (item = {}) => {
    const raw = Array.isArray(item.counties)
      ? item.counties
      : [item.county];
    return raw
      .map((county) => this.countyId(county))
      .filter((county, index, values) => county && values.indexOf(county) === index);
  };

  // to replace "country061" with value from Config/Platform (PLATFORM_DEFAULT_COUNTRY)
  updateGeoData = (countryId = 'country061', countyIds = []) => {
    let cached = COUNTY_CACHE.get(countryId);
    if (!cached) {
      const data = this.state.client.getData(
        Config.API_URL_COUNTY,
        { country: countryId, orderBy_Name: true }
      );
      const counties = Array.isArray(data?.counties) ? data.counties : [];
      const options = counties.map((county) => ({
        iref: String(county.iref),
        name: String(county.name || ''),
      }));
      const dict = {};
      options.forEach((county) => { dict[county.iref] = county.name; });
      cached = { options, dict };
      COUNTY_CACHE.set(countryId, cached);
    }

    const selectedIds = Array.isArray(countyIds)
      ? countyIds.map(String)
      : (countyIds ? [String(countyIds)] : []);
    const countyObjs = cached.options.filter(
      (county) => selectedIds.includes(county.iref)
    );
    this.setState({
      counties: cached.options,
      countyOpts: cached.dict,
      countyObjs,
    });
  };

  countyNames = (item = {}) => {
    const names = this.countyIds(item)
      .map((countyId) => this.state.countyOpts[countyId])
      .filter(Boolean);
    return names.length ? names.join(', ') : 'All';
  };

  selectedCountyIds = () => (
    this.state.targetMode === 'selected'
      ? this.countyIds(this.state.item)
      : []
  );

  countyTargetEnabled = () => Number(this.state.item.type) !== 0;

  targetSummary = () => {
    if (!this.countyTargetEnabled()) {
      return 'County targeting is inactive for Internal news.';
    }
    const count = this.selectedCountyIds().length;
    if (this.state.targetMode === 'all') {
      return 'All counties: one global news record will be saved.';
    }
    if (!count) return 'Select at least one county.';
    const prefix = this.state.item.groupId ? 'Saving updates' : 'Saving creates';
    return `${prefix} ${count} linked news ${count === 1 ? 'record' : 'records'}. Translations apply to every linked copy.`;
  };

  setTargetMode = (_, mode) => {
    if (!mode || !this.countyTargetEnabled()) return;
    this.setState((state) => ({
      targetMode: mode,
      countyObjs: mode === 'all' ? [] : state.countyObjs,
      item: mode === 'all'
        ? { ...state.item, county: null, counties: [] }
        : state.item,
      somethingHasChanged: true,
    }));
  };

  // make absolute URLs relative, so getData won't double-prefix
  toRelative = (u) => { if (!u) return ''; return String(u).replace(/^https?:\/\/[^/]+/i, ''); };
  // join base + path with exactly one slash
  joinUrl = (base, path) => {
    const b = (base || '').endsWith('/') ? base : (base + '/');
    const p = (path || '').startsWith('/') ? path.slice(1) : path;
    return b + p;
  };

  // ---------- languages & translations ----------
  async loadLanguages() {
    if (LANGS_CACHE && LANGS_BY_ID) {
      this.setState({ languages: LANGS_CACHE, langById: LANGS_BY_ID, languagesReady: true });
      return;
    }
    if (LANGS_LOADING) {
      await LANGS_LOADING;
      this.setState({ languages: LANGS_CACHE || [], langById: LANGS_BY_ID || {}, languagesReady: true });
      return;
    }
    LANGS_LOADING = (async () => {
      const urlBase = this.toRelative(this.props.API_URL_LANGUAGE || Config.API_URL_LANGUAGE || '/api/1.0/languages/');
      const data = this.state.client.getData(urlBase, {});
      const raw = Array.isArray(data?.Languages) ? data.Languages : [];
      const list = raw
        .map(x => ({ iref: String(x.iref), languageName: String(x.languageName || '').trim() }))
        .filter(x => x.iref && x.languageName);
      const map = {}; list.forEach(l => { map[l.iref] = l; });
      LANGS_CACHE = list; LANGS_BY_ID = map;
    })();
    try { await LANGS_LOADING; } finally { LANGS_LOADING = null; }
    this.setState({ languages: LANGS_CACHE, langById: LANGS_BY_ID, languagesReady: true });
  }

  async loadTranslations() {
    const id = this.state.item?.iref; if (!id) return;
    const base = this.toRelative(this.props.API_URL_NEWS || Config.API_URL_NEWS || '/api/1.0/news/');
    const url  = this.joinUrl(base, `${id}/translations/`);
    const data = this.state.client.getData(url, {});
    if (!data) { swal('Error','Could not load translations','error'); return; }

    const rows = Array.isArray(data?.translations) ? data.translations : [];
    const normalized = rows.map(r => {
      const langId = (r.language && typeof r.language === 'object')
        ? String(r.language.iref)
        : (r.language != null ? String(r.language) : null);
      return { ...r, language: langId };
    });
    this.setState({ translations: normalized });
  }

  onTrFieldChange = (iref, field, value) => {
    this.setState(s => ({ translations: (s.translations || []).map(r => String(r.iref) === String(iref) ? { ...r, [field]: value } : r) }));
  };

  saveTranslation = async (row) => {
    const newsId = this.state.item?.iref; if (!newsId) {
      swal('Error','Save the news first, then add translations.','error'); return;
    }
    if (!this.hasRequiredText(row.details)) {
      swal('Details required', 'Enter translation details before saving.', 'warning');
      return;
    }
    if (!this.hasRequiredText(row.description)) {
      swal('Description required', 'Enter a translation description before saving.', 'warning');
      return;
    }
    if (!this.hasValidDescription(row.description, TRANSLATION_DESCRIPTION_LIMIT)) {
      swal('Description too long', `Translation descriptions can contain up to ${TRANSLATION_DESCRIPTION_LIMIT} characters.`, 'warning');
      return;
    }
    this.setState({ isSavingTr: true });

    const isRealId = row.iref && Number(row.iref) > 0;
    const payload = {
      ...(isRealId ? { iref: row.iref } : {}),
      language_iref: row.language || null,
      name: (row.name ?? '').trim(),
      description: (row.description ?? '').trim(),
      details: (row.details ?? '').trim()
    };

    try {
      const base = this.toRelative(this.props.API_URL_NEWS || Config.API_URL_NEWS || '/api/1.0/news/');
      const url  = this.joinUrl(base, `${newsId}/translations_save/`);
      const data = this.state.client.pushData(url, payload); // POST via your client helper

      if (data && data.status === 'OK') {
        const saved  = data.row;
        const langId = saved?.language && typeof saved.language === 'object'
          ? String(saved.language.iref) : String(saved.language || '');
        const merged = { ...saved, language: langId || null };
        this.setState(s => {
          const list = [...s.translations];
          const idx = list.findIndex(x => x.iref === row.iref || x.iref === merged.iref);
          if (idx >= 0) list[idx] = merged; else list.unshift(merged);
          return { translations: list, isSavingTr: false, trEdit: { ...s.trEdit, [merged.iref]: false } };
        });
        swal('Saved','Translation saved.','success',{ buttons:false, timer:900 });
      } else {
        const msg = this.saveErrorMessage(data);
        swal('Save failed', msg, 'error'); this.setState({ isSavingTr: false });
      }
    } catch (e) {
      swal('Save failed', e.message || String(e), 'error');
      this.setState({ isSavingTr: false });
    }
  };

  addBlankTranslation = () => {
    if (this.hasOpenDraft()) {
      swal('Heads up', 'Please finish or cancel the current draft translation first.', 'info');
      return;
    }
    const tmpId = -Date.now();
    const newRow = { iref: tmpId, news: this.state.item?.iref, language: null, name: '', description: '', details: '' };
    this.setState(s => ({
      translations: [newRow, ...s.translations],
      trEdit: { ...s.trEdit, [tmpId]: true }
    }));
  };

  canEditTrRow = (t) =>
    !!this.state.allowEdit && ((this.state.trEdit && this.state.trEdit[t.iref]) || (t.iref < 0));
  
  toggleTrEdit(iref, force) {
    this.setState(s => ({
      trEdit: { ...s.trEdit, [iref]: typeof force === 'boolean' ? force : !s.trEdit?.[iref] }
    }));
  }
  
  hasOpenDraft = () => (this.state.translations || []).some(t => Number(t.iref) < 0);

  // ---------- changes ----------
  changeFrequency(v){ this.setState(s=>({ item:{...s.item, frequency: parseInt(v,10)}, somethingHasChanged:true })); }
  changeType(v){ this.setState(s=>({ item:{...s.item, type: parseInt(v,10)}, somethingHasChanged:true })); }
  changeDetailsLang(v){ this.setState(s=>({ item:{...s.item, detailsLanguage: parseInt(v,10)}, somethingHasChanged:true })); }
  changePinPosition(v){ this.setState(s => ({item: { ...s.item, pin_position: parseInt(v, 10) },somethingHasChanged: true })); }

  handleExpandClick(){ this.setState((s) => ({ expanded: !s.expanded })); }
  handleEditClick = () => {
    if (!this.state.allowEdit) return;
    this.setState(prev => {
      const img = prev.item.image || '';
      const clean = (typeof img === 'string') ? img.replace(/\s+/g, '').trim() : '';
      return { edit: true, saveButtonVisible: true, expanded: true, item: { ...prev.item, image: clean } };
    });
  };
  handleCancelClick = async () => {
    if (this.props.isNew) {
      if (typeof this.props.onCancel === 'function') this.props.onCancel();
      return;
    }
    if (this.state.somethingHasChanged) {
      const confirmed = await swal({
        title: 'Discard changes?',
        text: 'Your unsaved news changes will be lost.',
        icon: 'warning',
        buttons: ['Keep editing', 'Discard'],
        dangerMode: true,
      });
      if (!confirmed) return;
    }
    const restored = {
      ...this.originalItem,
      counties: [...this.countyIds(this.originalItem)],
    };
    const counties = this.countyIds(restored);
    this.setState({
      item: restored,
      edit: false,
      saveButtonVisible: false,
      somethingHasChanged: false,
      targetMode: counties.length ? 'selected' : 'all',
    }, () => this.updateGeoData('country061', counties));
  };
  handleSaveClick = () => {
    if (document?.activeElement?.blur) {
      document.activeElement.blur();
    }
    setTimeout(() => this.pushData(), 0);
  };
  handleTabChange = async (_, tab) => {
    this.setState({ tabValue: tab }, async () => { if (tab === 'translations') { await this.loadLanguages(); if (this.state.item?.iref) await this.loadTranslations(); } });
  };

  changeValue(e){ const id = e.target.id; const value = (e.target.type === 'checkbox') ? e.target.checked : e.target.value; this.setState(s => ({ item:{...s.item, [id]: value}, somethingHasChanged:true })); }
  getImage(newImage) {
    const raw = (newImage && typeof newImage === 'object') ? (newImage.data || '') : (newImage || '');
    const dataStr = String(raw).replace(/\s+/g, ''); // strip spaces/newlines
    this.setState(s => ({ item: { ...s.item, image: dataStr }, somethingHasChanged: true }));
  }

  // ---------- save ----------
  pushData = async () => {
    if (!(this.state.edit && this.state.somethingHasChanged)) { swal('Error', 'Nothing to save', 'error'); return; }
    if (!this.hasValidDates()) {
      swal('Missing or invalid period', 'Please select both From and To dates (From must be before To).', 'warning');
      return;
    }
    if (!this.hasRequiredText(this.state.item?.details)) {
      this.setState({ tabValue: 'details' });
      swal('Details required', 'Enter news details before saving.', 'warning');
      return;
    }
    if (!this.hasRequiredText(this.state.item?.description)) {
      this.setState({ tabValue: 'details' });
      swal('Description required', 'Enter a news description before saving.', 'warning');
      return;
    }
    if (!this.hasValidDescription(this.state.item.description, NEWS_DESCRIPTION_LIMIT)) {
      this.setState({ tabValue: 'details' });
      swal('Description too long', `News descriptions can contain up to ${NEWS_DESCRIPTION_LIMIT} characters. Put longer content in Details.`, 'warning');
      return;
    }

    const src = this.state.item;
    const counties = (
      this.countyTargetEnabled() && this.state.targetMode === 'selected'
        ? this.countyIds(src)
        : []
    );
    if (
      this.countyTargetEnabled()
      && this.state.targetMode === 'selected'
      && counties.length === 0
    ) {
      swal('Select counties', 'Choose at least one county or use All counties.', 'warning');
      return;
    }
    const originalCounties = this.countyIds(this.originalItem);
    const removedCounties = originalCounties.filter(
      (countyId) => !counties.includes(countyId)
    );
    if (src.iref && removedCounties.length) {
      const confirmed = await swal({
        title: 'Remove county copies?',
        text: `${removedCounties.length} linked news ${removedCounties.length === 1 ? 'copy' : 'copies'} will be removed. Remaining translations stay synchronized.`,
        icon: 'warning',
        buttons: ['Cancel', 'Continue'],
        dangerMode: true,
      });
      if (!confirmed) return;
    }

    this.setState({ isSaving: true });
    try {
      const originalIref = src.iref || null;
      const payload = { ...src };
      delete payload.createdOn;
      delete payload.modifiedOn;
      delete payload.groupId;
      delete payload.county;
      payload.description = String(src.description ?? '').trim();
      payload.counties = counties;
      payload.dateFrom = this.toPayloadDate(src.dateFrom, false, true); payload.dateTo = this.toPayloadDate(src.dateTo, true, true);
      const base = this.props.API_URL_NEWS || Config.API_URL_NEWS || '/api/1.0/news/';
      const r = this.state.client.pushJson(base, payload);
      if (r && r.status === 'OK') {
        const next = { ...this.state.item, ...r };
        delete next.status;
        this.originalItem = {
          ...next,
          counties: [...this.countyIds(next)],
        };
        this.setState({
          item: next,
          somethingHasChanged: false,
          isSaving: false,
          edit: false,
          saveButtonVisible: false,
        });
        swal('Saved', 'News saved successfully.', 'success', { buttons: false, timer: 1200 });
        if (typeof this.props.onUpdated === 'function') {
          this.props.onUpdated(next, originalIref);
        }
        return;
      }
      const msg = this.saveErrorMessage(r);
      swal('Save failed', msg, 'error'); this.setState({ isSaving: false });
    } catch (e) { const msg = (e && e.message) ? e.message : String(e); swal('Save failed', msg, 'error'); this.setState({ isSaving: false }); }
  };

  isValidDataUrl = (s) => {
    if (typeof s !== 'string') return false;
    const m = s.match(/^data:image\/(png|jpe?g|gif|webp);base64,([A-Za-z0-9+/=]+)$/i);
    return !!(m && m[2] && m[2].length > 16); // crude sanity: some payload length
  };

  _onKImageSaveBack = (img) => {
    const raw = (img && typeof img === 'object') ? (img.data || '') : (img || '');
    const dataStr = String(raw).replace(/\s+/g, '');
    this.setState(s => ({
      item: { ...s.item, image: dataStr },
      somethingHasChanged: true,
      imgVersion: (s.imgVersion || 0) + 1,      
    }));
  };

  // ---------- render ----------
  render() {
    const p = this.state.item || {};
    const title = p.name || 'New News';
    const detailsValid = this.hasRequiredText(p.details);
    const descriptionValid = this.hasValidDescription(p.description, NEWS_DESCRIPTION_LIMIT);
    const countyTargetEnabled = this.countyTargetEnabled();
    const selectedCountyCount = this.selectedCountyIds().length;
    const countyTargetValid = (
      !countyTargetEnabled
      || this.state.targetMode === 'all'
      || selectedCountyCount > 0
    );

    let newsImage = p.image;
    if (newsImage && typeof newsImage === 'object') newsImage = newsImage.data || newsImage.url || newsImage.src || '';
    if (typeof newsImage !== 'string') newsImage = '';
    newsImage = newsImage.trim();
    if (!newsImage) {
      newsImage = noImage;
    } else {
      const isDataUrl = newsImage.startsWith('data:');
      const isHttp   = /^https?:\/\//i.test(newsImage);
      const isPath   = newsImage.startsWith('/') || newsImage.startsWith('./') || newsImage.startsWith('../');

      if (isDataUrl) {
        // validate
        if (!this.isValidDataUrl(newsImage)) newsImage = noImage;
      } else if (isHttp || isPath) {
        // add _s thumbnail suffix for file/URL images only
        try {
          const dot = newsImage.lastIndexOf('.');
          const slash = newsImage.lastIndexOf('/');
          if (dot > -1 && dot > slash) {
            const base = newsImage.slice(0, dot);
            const ext  = newsImage.slice(dot + 1);
            newsImage  = `${base}_s.${ext}`;
          }
        } catch {}
      } else {
        // anything else -> placeholder
        newsImage = noImage;
      }
    }

    const activeAvatar = p.isActive ? active_on : active_off; const activeAlt = p.isActive ? 'Active' : 'Inactive';

    const imgRaw = this.state.item?.image || '';
    if (imgRaw !== this._lastImgRaw) {
      this._kimgImageObj = { data: imgRaw };
      this._lastImgRaw = imgRaw;
    }

    const detailsEdit = (() => {
      const p = this.state?.item || {};
      if (p.type == null || !(p.type in this.state.typeOptions)) {
        p.type = 1;
      }

      return (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: '220px minmax(0, 1fr)' },
            gap: 1.5,
            alignItems: 'start',
          }}
        >
          <Box sx={{ width: { xs: 220, sm: '100%' }, maxWidth: '100%', minWidth: 0 }}>
            <StableKImage
              edit={this.state.edit}
              image={this._kimgImageObj}
              imageText="News image"
              saveBack={this._onKImageSaveBack}
              version={this.state.imgVersion}
              key={this.state.imgVersion}
            />
          </Box>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(12, minmax(0,1fr))',
              gap: 1.25,
              alignItems: 'start',
              minWidth: 0,
              '& .MuiFormControl-root': { m: 0, width: '100%', minWidth: 0, maxWidth: '100%' },
              '& .MuiInputBase-root': { minWidth: 0 },
              '& .MuiSelect-select': { overflow: 'hidden', textOverflow: 'ellipsis' },
            }}
          >
              <Box sx={{
                  gridColumn: { xs: 'span 12', md: 'span 4', lg: 'span 2' },
                  display: 'flex',
                  alignItems: 'center',
                  minWidth: 0,
                }}
              >
                <FormControlLabel
                  sx={{ m: 0, width: '100%' }}
                  control={
                    <Switch
                      id="isActive"
                      size="small"
                      checked={!!p.isActive}
                      onChange={(e) =>
                        this.changeValue({
                          target: { id: 'isActive', type: 'checkbox', checked: e.target.checked },
                        })
                      }
                    />
                  }
                  label="Active"
                />
              </Box>

              <Box sx={{ gridColumn: { xs: 'span 12', md: 'span 8', lg: 'span 6' }, minWidth: 0 }}>
                <TextField
                  id="name"
                  label="Name"
                  value={p.name || ''}
                  onChange={this.changeValue}
                  size="small"
                  variant="outlined"
                  fullWidth
                  inputProps={{ maxLength: 128 }}
                />
              </Box>

              <Box sx={{ gridColumn: { xs: 'span 6', lg: 'span 2' }, minWidth: 0 }}>
                <Box sx={{ minWidth: 0, width: '100%' }}>
                  <DropDown
                    name="Type"
                    value={String(p.type ?? 1)}
                    size="small"
                    doptions={this.state.typeOptions}
                    hasIcons={false}
                    onDark={false}
                    onChangeFunction={this.changeType}
                  />
                </Box>
              </Box>

              <Box sx={{ gridColumn: { xs: 'span 6', lg: 'span 2' }, minWidth: 0 }}>
                <Box sx={{ minWidth: 0, width: '100%' }}>
                  <DropDown
                    name="Frequency"
                    value={String(p.frequency ?? 0)}
                    size="small"
                    doptions={this.state.frequencyOptions}
                    hasIcons={false}
                    onDark={false}
                    onChangeFunction={this.changeFrequency}
                  />
                </Box>
              </Box>

              <Box sx={{ gridColumn: { xs: 'span 6', lg: 'span 2' }, minWidth: 0 }}>
                <Box sx={{ minWidth: 0, width: '100%' }}>
                  <DropDown
                    name="Top position"
                    value={String(p.pin_position ?? 0)}
                    size="small"
                    doptions={this.state.pinOptions}
                    hasIcons={false}
                    onDark={false}
                    onChangeFunction={this.changePinPosition}
                  />
                </Box>
              </Box>

              <Box sx={{ gridColumn: { xs: 'span 6', lg: 'span 2' }, minWidth: 0 }}>
                <DropDown
                  name="Details language"
                  value={String(p.detailsLanguage ?? 0)}
                  size="small"
                  doptions={this.state.detailsLangOptions}
                  hasIcons={false}
                  onDark={false}
                  onChangeFunction={this.changeDetailsLang}
                />
              </Box>

              <Box sx={{ gridColumn: { xs: 'span 12', md: 'span 6', lg: 'span 4' }, minWidth: 0 }}>
                <TextField
                  id="dateFrom_ui"
                  label="From"
                  type="datetime-local"
                  inputProps={{ step: 60 }}
                  size="small"
                  variant="outlined"
                  fullWidth
                  value={this.toDateTimeInput(p.dateFrom, false)}
                  onChange={(e) => this.changeSchedule('dateFrom', e.target.value)}

                  InputLabelProps={{ shrink: true }}
                  error={!p.dateFrom}
                  helperText={!p.dateFrom ? 'Required' : 'Europe/Bucharest'}
                />
              </Box>

              <Box sx={{ gridColumn: { xs: 'span 12', md: 'span 6', lg: 'span 4' }, minWidth: 0 }}>
                <TextField
                  id="dateTo_ui"
                  label="To"
                  type="datetime-local"
                  inputProps={{ step: 60 }}
                  size="small"
                  variant="outlined"
                  fullWidth
                  value={this.toDateTimeInput(p.dateTo, true)}
                  onChange={(e) => this.changeSchedule('dateTo', e.target.value)}

                  InputLabelProps={{ shrink: true }}
                  error={!p.dateTo || (!!p.dateFrom && !this.hasValidDates())}
                  helperText={!p.dateTo ? 'Required' : p.dateFrom && !this.hasValidDates() ? 'To must be on or after From' : 'Europe/Bucharest'}
                />
              </Box>

              <Box sx={{
                gridColumn: '1 / -1',
                minWidth: 0,
                p: 1.25,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
              }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', gap: 0.75, mb: 1 }}>
                  <Typography variant="subtitle2">Client targeting</Typography>
                  <Typography
                    variant="caption"
                    color={countyTargetValid ? 'text.secondary' : 'error.main'}
                    role={countyTargetValid ? undefined : 'alert'}
                  >
                    {this.targetSummary()}
                  </Typography>
                </Box>
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: '240px minmax(0, 1fr)' },
                  gap: 1,
                  alignItems: 'start',
                }}>
                  <ToggleButtonGroup
                    exclusive
                    fullWidth
                    size="small"
                    aria-label="County targeting mode"
                    value={this.state.targetMode}
                    onChange={this.setTargetMode}
                    disabled={!countyTargetEnabled}
                  >
                    <ToggleButton value="all">All counties</ToggleButton>
                    <ToggleButton value="selected">Selected</ToggleButton>
                  </ToggleButtonGroup>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  disabled={!countyTargetEnabled || this.state.targetMode === 'all'}
                  options={this.state.counties}
                  getOptionLabel={(opt) => opt?.name || ''}
                  isOptionEqualToValue={(a, b) => a?.iref === b?.iref}
                  value={this.state.countyObjs}
                  limitTags={2}
                  ListboxProps={{ style: { height: 144, maxHeight: 144 } }}
                  sx={{
                    '& .MuiAutocomplete-inputRoot': {
                      maxHeight: 112,
                      overflowY: 'auto',
                      alignItems: 'flex-start',
                    },
                  }}
                  size="small"
                  onChange={(_, val) =>
                    this.setState((s) => ({
                      countyObjs: val || [],
                      item: {
                        ...s.item,
                        county: val?.[0]?.iref || null,
                        counties: (val || []).map((county) => county.iref),
                      },
                      somethingHasChanged: true,
                    }))
                  }
                  onOpen={() => {
                    if (!this.state.counties || this.state.counties.length === 0) {
                      this.updateGeoData('country061', this.countyIds(this.state.item));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Client counties"
                      error={!countyTargetValid}
                      fullWidth
                    />
                  )}
                />
                </Box>
              </Box>

            <Box sx={{ gridColumn: '1 / -1', minWidth: 0 }}>
              <TextField
                id="description"
                label="Description"
                value={p.description || ''}
                onChange={this.changeValue}
                variant="outlined"
                fullWidth
                multiline
                minRows={2}
                maxRows={5}
                required
                error={!descriptionValid}
                helperText={this.descriptionHelperText(p.description, NEWS_DESCRIPTION_LIMIT)}
              />
            </Box>

            <Box sx={{ gridColumn: '1 / -1', minWidth: 0 }}>
              <TextField
                id="details"
                label="Details"
                value={p.details || ''}
                onChange={this.changeValue}
                variant="outlined"
                fullWidth
                multiline
                minRows={4}
                maxRows={10}
                required
                error={!detailsValid}
                helperText={!detailsValid ? 'Required' : undefined}
              />
            </Box>
          </Box>
        </Box>
      );
    })();

    const detailsReadOnly = (
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'minmax(0, 1fr)',
            md: 'minmax(0, 2fr) minmax(240px, 1fr)',
          },
          gap: 1.25,
          alignItems: 'start',
        }}
      >
        <Box
          sx={{
            p: 1.5,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            minWidth: 0,
          }}
        >
          <Typography variant="subtitle2" sx={{ mb: 0.75 }}>
            Details ({this.state.detailsLangOptions[p.detailsLanguage] || '—'})
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              whiteSpace: 'pre-wrap',
              overflowWrap: 'anywhere',
              wordBreak: 'break-word',
            }}
          >
            {p.details || '—'}
          </Typography>
        </Box>

        <Box sx={{ p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1, minWidth: 0, display: 'grid', gap: 1.25 }}>
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 0.25 }}>Description</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
              {p.description || '—'}
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 0.25 }}>Schedule</Typography>
            <Typography variant="body2" color="text.secondary">
              {p.dateFrom ? `From: ${this.scheduleLabel(p.dateFrom)}` : 'From: —'}
              <br />
              {p.dateTo ? `To: ${this.scheduleLabel(p.dateTo, true)}` : 'To: —'}
              <br />
              <Typography component="span" variant="caption">Europe/Bucharest</Typography>
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 0.25 }}>Publishing &amp; targeting</Typography>
            <Typography variant="body2" color="text.secondary">
              {this.state.typeOptions[p.type] || '—'} · {this.state.frequencyOptions[p.frequency] || '—'} · Top: {this.state.pinOptions[p.pin_position] || 'None'}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ overflowWrap: 'anywhere' }}>
              Client counties: {this.countyNames(p)}
            </Typography>
          </Box>
        </Box>
      </Box>
    );

    const translationsTab = (
      <Box sx={{ p: 1, display:'grid', gridTemplateColumns:'1fr', gap: 1 }}>
        {this.state.allowEdit && this.state.item?.iref && (
          <Box sx={{ display:'flex', gap: 1, justifyContent:'flex-end' }}>
            <Button size="small" variant="outlined" onClick={this.addBlankTranslation} disabled={this.hasOpenDraft()}>Add translation</Button>
          </Box>
        )}
        {this.state.translations.length === 0 ? (
          <Typography variant="body2" color="text.secondary">No translations yet.</Typography>
        ) : (
          this.state.translations.map((t) => {
            const isTemp = (t.iref < 0);
            return (
              <Box
                key={t.iref}
                sx={{
                  p: 0.5,
                  borderRadius: 1,
                  border: '1px solid #e0e0e0',
                  display: 'grid',
                  gridTemplateColumns: '200px 1fr',
                  gap: 0.5
                }}
              >
                {/* Language */}
                <Box sx={{ display:'grid', gap: 0.25 }}>
                  {this.canEditTrRow(t) ? (
                    <Autocomplete
                      options={this.state.languages}
                      size="small"
                      disablePortal
                      getOptionLabel={(opt) => opt?.languageName || ''}
                      isOptionEqualToValue={(opt, val) => opt?.iref === val?.iref}
                      value={(this.state.languagesReady && t.language) ? (this.state.langById[t.language] || null) : null}
                      onChange={(_, val) => this.onTrFieldChange(t.iref, 'language', val ? val.iref : null)}
                      renderInput={(params) => <TextField {...params} variant="outlined" label="Language" size="small" />}
                      ListboxProps={{ sx: { maxHeight: 200, p: 0 } }}
                      sx={{ minWidth: 200, mt: 1 }}
                      disabled={!this.state.languagesReady}
                    />
                  ) : (
                    <>
                      <Typography variant="caption" color="text.secondary">Language</Typography>
                      <Typography variant="body2">
                        {!this.state.languagesReady ? '…' : (t.language ? (this.state.langById[t.language]?.languageName || '—') : '—')}
                      </Typography>
                    </>
                  )}
                </Box>

                {/* Fields */}
                <Box sx={{ display:'grid', gap: 0.25 }}>
                  {this.canEditTrRow(t) ? (
                    <Box
                      sx={{
                        display:'grid',
                        gridTemplateColumns:'1fr 2fr auto',
                        columnGap: 0.5,
                        rowGap: 0.25,
                        alignItems:'flex-start'
                      }}
                    >
                      {/* Name */}
                      <TextField
                        size="small" margin="dense" label="Name" variant="outlined"
                        value={t.name || ''} inputProps={{ maxLength: 100 }}
                        onChange={(e)=>this.onTrFieldChange(t.iref, 'name', e.target.value)}
                      />
                      {/* Description */}
                      <TextField
                        size="small" margin="dense" label="Description" variant="outlined"
                        value={t.description || ''}
                        onChange={(e)=>this.onTrFieldChange(t.iref, 'description', e.target.value)}
                        required
                        error={!this.hasValidDescription(t.description, TRANSLATION_DESCRIPTION_LIMIT)}
                        helperText={this.descriptionHelperText(t.description, TRANSLATION_DESCRIPTION_LIMIT)}
                      />
                      {/* Actions */}
                      <Box sx={{ display:'flex', gap: 0.5, justifyContent:'flex-end', mt: 2 }}>
                        <Button size="small" variant="contained" disabled={this.state.isSavingTr || !this.hasRequiredText(t.details) || !this.hasValidDescription(t.description, TRANSLATION_DESCRIPTION_LIMIT)} onClick={()=>this.saveTranslation(t)}>
                          {this.state.isSavingTr ? 'Saving…' : (isTemp ? 'Add' : 'Save')}
                        </Button>
                        <Button size="small" onClick={()=>{
                          if (t.iref < 0) {
                            this.setState(s => ({
                              translations: (s.translations || []).filter(x => x.iref !== t.iref),
                              trEdit: { ...s.trEdit, [t.iref]: false }
                            }));
                          } else {
                            this.toggleTrEdit(t.iref, false);
                          }
                        }}>Cancel</Button>
                      </Box>

                      {/* Details (full width, below) */}
                      <TextField
                        size="small" margin="dense" fullWidth
                        label="Details" variant="outlined"
                        multiline rows={3}
                        value={t.details || ''}
                        onChange={(e)=>this.onTrFieldChange(t.iref, 'details', e.target.value)}
                        required
                        error={!this.hasRequiredText(t.details)}
                        helperText={!this.hasRequiredText(t.details) ? 'Required' : undefined}
                        sx={{ gridColumn: '1 / span 3' }}
                      />
                    </Box>
                  ) : (
                    <>
                      <Box sx={{ display:'flex', gap: 1, flexWrap:'wrap', alignItems:'baseline' }}>
                        <Typography variant="subtitle2">{t.name || '—'}</Typography>
                        <Typography variant="body2" color="text.secondary">{t.description || '—'}</Typography>
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace:'pre-wrap' }}>
                        {t.details || '—'}
                      </Typography>
                      {this.state.allowEdit && (
                        <Box sx={{ display:'flex', justifyContent:'flex-end', mt: 0.5 }}>
                          <Button size="small" onClick={()=>this.toggleTrEdit(t.iref, true)}>Edit</Button>
                        </Box>
                      )}
                    </>
                  )}
                </Box>
              </Box>
            );
          })
        )}
      </Box>
    );

    const saveButtonVisible = (
      this.state.edit
      && this.state.somethingHasChanged
      && countyTargetValid
      && detailsValid
      && descriptionValid
    );
    const subheaderParts = [];
    if (p.iref) subheaderParts.push(`News #${p.iref}`);
    if (p.createdOn) subheaderParts.push(`Created: ${p.createdOn}`);
    if (p.modifiedOn) subheaderParts.push(`Modified: ${p.modifiedOn}`);

    return (
      <Card sx={{ borderRadius: '16px', m: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <CardHeader
            avatar={<Avatar alt={activeAlt} src={activeAvatar} title={activeAlt} />}
            action={
              <Box sx={{ display: 'flex', gap: 0.75, alignItems: 'center' }}>
                {this.state.edit ? (
                  <>
                    {this.state.somethingHasChanged ? (
                      <Typography variant="caption" color="warning.main" sx={{ display: { xs: 'none', sm: 'inline' }, whiteSpace: 'nowrap' }}>
                        Unsaved changes
                      </Typography>
                    ) : null}
                    <Button
                      size="small"
                      variant="text"
                      disabled={this.state.isSaving}
                      onClick={this.handleCancelClick}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<SaveIcon />}
                      disabled={this.state.isSaving || !saveButtonVisible || !this.hasValidDates()}
                      onClick={this.handleSaveClick}
                    >
                      {this.state.isSaving ? 'Saving…' : 'Save'}
                    </Button>
                  </>
                ) : (
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<EditIcon />}
                    onClick={this.handleEditClick}
                    disabled={!this.state.allowEdit}
                  >
                    Edit
                  </Button>
                )}
                <ExpandMore
                  expand={this.state.expanded}
                  onClick={this.handleExpandClick}
                  aria-expanded={this.state.expanded}
                  aria-label={this.state.expanded ? 'Hide news details' : 'Show news details'}
                >
                  <ExpandMoreIcon />
                </ExpandMore>
              </Box>
            }
            title={
              <Box sx={{ display: 'flex', gap: 0.75, alignItems: 'center', flexWrap: 'wrap' }}>
                <Typography variant="h6" sx={{ fontWeight: 600, overflowWrap: 'anywhere' }}>{title}</Typography>
                <Chip
                  size="small"
                  label={p.isActive ? 'Active' : 'Inactive'}
                  color={p.isActive ? 'success' : 'default'}
                  variant="outlined"
                />
                <Chip
                  size="small"
                  label={
                    this.countyIds(p).length
                      ? `${this.countyIds(p).length} ${this.countyIds(p).length === 1 ? 'county' : 'counties'}`
                      : 'All counties'
                  }
                  color="primary"
                  variant="outlined"
                />
              </Box>
            }
            subheader={subheaderParts.join(' • ')}
            disableTypography
            sx={{
              '& .MuiCardHeader-content': { minWidth: 0 },
              '& .MuiCardHeader-action': { alignSelf: 'center', m: 0, ml: 'auto' },
              flexWrap: 'wrap',
              gap: 0.75,
              pb: this.state.edit ? 1 : 0.5,
            }}
          />

          {!this.state.edit ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, px: 2, pb: 1 }}>
              <CardMedia
                component="img"
                sx={{ width: 80, height: 80, flexShrink: 0, borderRadius: 1, objectFit: 'cover' }}
                src={newsImage}
                alt={title}
                onError={(e) => { e.currentTarget.src = noImage; }}
              />
              <Box sx={{ minWidth: 0, display: 'grid', gap: 0.5 }}>
                <Typography variant="body2" color="text.secondary" noWrap title={p.description || ''}>
                  {p.description || 'No description'}
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  <Chip size="small" label={this.state.typeOptions[p.type] || 'Unknown type'} />
                  <Chip size="small" label={this.state.frequencyOptions[p.frequency] || 'Unknown frequency'} />
                  {p.pin_position > 0 ? (
                    <Chip size="small" color="secondary" label={`Top: ${this.state.pinOptions[p.pin_position]}`} />
                  ) : null}
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: 'anywhere' }}>
                  {p.dateFrom ? `From ${this.scheduleLabel(p.dateFrom)}` : 'No start date'}
                  {p.dateTo ? ` to ${this.scheduleLabel(p.dateTo, true)}` : ''} · Europe/Bucharest
                </Typography>
              </Box>
            </Box>
          ) : null}

          <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
            <CardContent sx={{ pt: 0.5, pb: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Box sx={{ width: '100%' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', minWidth: 0 }}>
                  <Tabs value={this.state.tabValue} onChange={this.handleTabChange} variant="scrollable" scrollButtons="auto" indicatorColor="secondary" sx={{ minHeight: 44, mb: 1, maxWidth: '100%' }}>
                    <Tab label="Details" value="details" icon={<DescriptionIcon />} iconPosition="start" sx={{ minHeight: 44 }} />
                    <Tab label="Translations" value="translations" icon={<TranslateIcon />} iconPosition="start" sx={{ minHeight: 44 }} />
                  </Tabs>
                </Box>
                {this.state.tabValue === 'details' ? (this.state.edit ? detailsEdit : detailsReadOnly) : translationsTab}
              </Box>
            </CardContent>
          </Collapse>
        </Box>
      </Card>
    );
  }
}
